import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_MEMBERSHIP_IDENTIFIED_LOGIN_GATE = defineFcm('revenue_membership_identified_login_gate')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Membership Join Page and Membership Offer',
		description:
			'Gates the experiment that asks identified (email-link) sessions to log in before vaulting a payment method for a membership; when unset or disabled they proceed and hit the generic payment error',
		template: {
			enabled: false,
			experimentName: '',
		},
	});
